'use client';
import React from 'react';
export var ModalContext = /*#__PURE__*/React.createContext(null);